// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/received-invoices/:id',
        component: () =>
            import(/* webpackChunkName: "shared-bills" */ '@/pages/[organisation]/payables/received-invoices/received-invoice/[id].vue'),
        name: 'received-invoices.view-invoice',
        meta: {
            guestRequired: false,
            loginRequired: false,
            permission: '*',
        },
    },
];
